import { get } from "lodash";
import { getBreedNames, getPetAges, getPetTypes } from "../../utils/petDataMapper";
import customEventAnalyticsMapping from "./customEventMappings";

export const getQuoteClickedMapping = (data) => {
    const mapping = customEventAnalyticsMapping.getMyQuoteClicked;
    const productData = get(data, "pets", []);
    const petsData = productData.filter((item) => item.quotes.length && item.quotes);
    const cartLineItemId = petsData.map((item) => {
        if (item.cartLineItemId) {
            return item.cartLineItemId;
        } else {
            return "[NOT SET]";
        }
    });

    mapping.petType = getPetTypes(petsData).join(",");
    mapping.breedNames = getBreedNames(petsData).join(",");
    mapping.petAge = getPetAges(petsData).join(",");
    mapping.cartLineItemId = cartLineItemId.join(",");
    mapping.email = get(data, "email", "");
    mapping.zipCode = get(data, "pets[0].zip", "");

    return mapping;
};

export const getStartQuoteClickMapping = () => {
    const mapping = customEventAnalyticsMapping.getQuote;

    return mapping;
};

export const getStartQuoteSubmitMapping = () => {
    const mapping = customEventAnalyticsMapping.getQuoteSubmit;

    return mapping;
};
